import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';
import { AdminRole } from '../../constants/adminRoles';

export interface Admin {
  id: string;
  fullName: string;
  username: string;
  phoneNumber: string;
  email: string | null;
  role: AdminRole;
  status: 'active' | 'inactive';
  createdAt: string;
  updatedAt: string;
}

export interface AdminListResponse {
  admins: Admin[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface CreateAdminInput {
  fullName: string;
  username?: string;
  phoneNumber: string;
  email?: string;
  role: AdminRole;
  password?: string;
}

export interface UpdateAdminInput {
  fullName?: string;
  phoneNumber?: string;
  email?: string;
  role?: AdminRole;
  status?: 'active' | 'inactive';
  password?: string;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
  message?: string;
}

class AdminService {
  async getAll(params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
    role?: string;
  }): Promise<AdminListResponse> {
    const res = await apiClient.get<ApiEnvelope<AdminListResponse>>(
      API_ENDPOINTS.ADMINS.GET_ALL,
      { params }
    );
    return res.data.data;
  }

  async getOne(id: string): Promise<Admin> {
    const res = await apiClient.get<ApiEnvelope<Admin>>(
      API_ENDPOINTS.ADMINS.GET_ONE(id)
    );
    return res.data.data;
  }

  async create(input: CreateAdminInput): Promise<Admin> {
    const res = await apiClient.post<ApiEnvelope<Admin>>(
      API_ENDPOINTS.ADMINS.CREATE,
      input
    );
    return res.data.data;
  }

  async update(id: string, input: UpdateAdminInput): Promise<Admin> {
    const res = await apiClient.patch<ApiEnvelope<Admin>>(
      API_ENDPOINTS.ADMINS.UPDATE(id),
      input
    );
    return res.data.data;
  }

  async toggleStatus(id: string): Promise<Admin> {
    const res = await apiClient.patch<ApiEnvelope<Admin>>(
      API_ENDPOINTS.ADMINS.TOGGLE_STATUS(id)
    );
    return res.data.data;
  }

  async delete(id: string): Promise<void> {
    await apiClient.delete(API_ENDPOINTS.ADMINS.DELETE(id));
  }
}

const adminService = new AdminService();
export default adminService;